import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DirectWizardData, RoomWizardData, submitDirectWizard, submitRoomWizard } from './option-wizard';
import { optionGroupsKeys } from './option-groups.queryKeys';

export function useSubmitRoomWizard() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: RoomWizardData) => submitRoomWizard(data),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ['getOptionItemsByGroup', data.id] });

            queryClient.invalidateQueries({ queryKey: optionGroupsKeys.root });
        },
    });
}

export function useSubmitDirectWizard() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: DirectWizardData) => submitDirectWizard(data),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ['getOptionItemsByGroup', data.id] });
            queryClient.invalidateQueries({ queryKey: optionGroupsKeys.root });
        },
    });
}
